'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'magnifying-glass-minus';
var width = 576;
var height = 512;
var aliases = ["search-minus"];
var unicode = 'f010';
var svgPathData = 'M240.4 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l133.9 133.9 17 17 33.9-33.9-17-17-133.9-133.9c28.1-35.5 44.9-80.3 44.9-129.1 0-114.9-93.1-208-208-208s-208 93.1-208 208 93.1 208 208 208zm-72-232l-24 0 0 48 192 0 0-48-168 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMagnifyingGlassMinus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;